<header class="kexp-header">
  <div class="header-container">
    <div class="station-logo-container">
      <a href="https://kexp.org/" target="_blank">
        <img src="/assets/kexp-rectangle-logo.svg" alt="KEXP"/>
      </a>
    </div>
    <div class="app-name">
      <h1>
        <a class="clean-link" routerLink="/">Extended Archive</a>
      </h1>
    </div>
    <div class="donate-button-container">
      <a href="https://www.kexp.org/donate/" class="donate-button">
        <div class="contribute-link">DONATE</div>
      </a>
    </div>
  </div>
</header>
